<template>
  <div>

    <TitlePage :title="$t('fixed_bookings')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler" :delete-permission="false"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile>
      <v-row class="mt-0 pl-4 pr-4 align-center">

        <v-col cols="12" md="2" class="pt-2 pb-0">
          <SportsAutocompleteSingle @message="setSportId"></SportsAutocompleteSingle>
        </v-col>

        <v-col cols="12" md="2" class="pt-2 pb-0">
          <v-select :items="statuses" label="Stato" item-text="text" item-value="value" v-model="filter.active"></v-select>
        </v-col>
      </v-row>
      <v-row class="mt-0 pl-4 pr-4 align-center">
        <v-col cols="12" md="12" class="pt-2 pb-2 text-right">
          <v-btn elevation="2" color="primary" small class="mr-2" @click="makeSearch(true)">
            <v-icon left>mdi-card-search</v-icon>
            {{ $t('search') }}
          </v-btn>
          <v-btn elevation="2" color="error" small class="mr-2" @click="resetFilter()">
            RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>

      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.field="{ item }">
          <template v-if="item.field[0]">
            {{ item.field[0].name }}
          </template>
          <template v-else>
            N.D.
          </template>
        </template>

        <template v-slot:item.sport="{ item }">
          {{ item.sport[0].name }}
        </template>

        <template v-slot:item.customer="{ item }">
          <template v-if="item.customer[0]">
            {{ item.customer[0].name }} {{ item.customer[0].surname }}
          </template>
          <template v-else-if="item.note">
            {{item.note}}
          </template>
          <template v-else>
            N.D.
          </template>
        </template>

        <template v-slot:item.price="{ item }">
          {{ item.price.toFixed(2) }} €
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip small :color="item.active ? 'green':'error'" text-color="white">{{(item.active) ? 'Attivo':'Disattivato'}}</v-chip>
        </template>

        <template v-slot:item.slot_id="{item}">
          {{getSlot(item.slot_id, item.day_id)}}
        </template>

        <template v-slot:item.date_start="{ item }">
          {{ formatDate(item.date_start.split('T')[0]) }}
        </template>

        <template v-slot:item.date_end="{ item }">
          {{ item.date_end ? formatDate(item.date_end.split('T')[0]) : 'Nessuna scadenza' }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon @click="goToMasterCalendar(item.field_id)" :title="$t('edit')" color="primary">mdi-file-edit</v-icon>
          <v-icon @click="confirmRemove(item._id)" :title="$t('delete')" color="primary">mdi-delete</v-icon>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>

    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>


  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import SportsAutocompleteSingle from "@/components/admin/SportsAutocompleteSingle";

const exportService = require('@/services/export')

export default {
  name: 'Bookings',
  components: {ItemActions, ModalDelete, TitlePage, CenterAutocomplete,SportsAutocompleteSingle},
  data() {
    return {
      search: '',
      selected: [],
      headers: [
        {text: this.$t('field'), value: 'field', sortable: false},
        {text: this.$t('sports'), value: 'sport', sortable: false},
        {text: this.$t('customer'), align: 'start', value: 'customer', sortable: false},
        {text: this.$t('amount'), value: 'price', sortable: false},
        {text: this.$tc('day')+' - '+this.$tc('hour'), value: 'slot_id'},
        {text: this.$t('status'), value: 'active'},
        {text: this.$t('dateStart'), value: 'date_start'},
        {text: this.$t('dateEnd'), value: 'date_end'},
        {text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      statuses: [
        {text: "", value: ""},
        {text: "Attivo", value: true},
        {text: "Disattivato", value: false},
      ],
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100],
      pathMasterCalendar: '/fields/master-calendar/',
    };
  },
  async created() {
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)
    if(this.$route.query.user_id && this.getUser.super_admin){
      this.filter.user_id = this.$route.query.user_id
    }else {
      delete this.filter.user_id
    }
    if(this.$route.params.id && this.getUser.super_admin){
      this.filter.center_id = this.$route.params.id
    }else {
      delete this.filter.center_id
    }
    if(this.$route.query.field_id && this.getUser.super_admin){
      this.filter.field_id = this.$route.query.field_id
    }else {
      delete this.filter.field_id
    }
    await this.makeSearch()
  },
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
      'getFilter':'fixed_bookings/getFilter',
      'getOptionsPagination':'fixed_bookings/getOptionsPagination',
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'fixed_bookings/index',
      'deleteItem': 'fixed_bookings/delete',
      'massiveDeleteItem': 'fixed_bookings/massDelete',
      'setFilter': 'fixed_bookings/setFilter',
      'setOptionsPagination': 'fixed_bookings/setOptionsPagination',
    }),

    async resetFilter(){
      let filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }
      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      let results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },


    confirmRemove(id) {
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove() {
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode) {
      if (this.typeDelete === 'single') {
        await this.remove(mode)
      } else if (this.typeDelete === 'massive') {
        await this.massiveRemove(mode)
      } else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode) {

      if (!mode) {

        this.modalDelete = false

      } else {

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.deleteItem({id: this.ids_to_delete[0]})

        if (result.success) {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          let results = await this.getItems({filter: this.filter, pagination: this.options_pagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        } else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode) {
      if (!mode) {

        this.modalDelete = false

      } else {

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.massiveDeleteItem({_id: {$in: this.ids_to_delete}})

        if (result.success) {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter: this.filter, pagination: this.options_pagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        } else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async getNewPage() {
      await this.makeSearch()
    },
    calculatePagination(count, limit) {
      let divide = (count / limit)
      let rest = divide % 1
      if (rest > 0) {
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }
      return +divide
    },
    async setSportId(sport){
      this.filter.sport_id = sport._id
    },
    getSlot(slot_id, day_id) {
      let dayNames = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
      return `${dayNames[day_id]} - ${slot_id.replace(';','-')}`
    },
    formatDate(my_date){
      let split = my_date.split('-')
      return split[2]+'/'+split[1]+'/'+split[0]
    },
    async export(){
      let csv = await exportService.getCsv(this.headers, this.items)
      let encodedUri = encodeURI(csv);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    goToMasterCalendar(id){
      this.$router.push(this.pathMasterCalendar+id)
    },
  },
  mounted() {

  },
}
</script>
